import React from "react";
import { Button, Space, Typography } from "antd";
import { LockOutlined, RocketOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

const { Title, Text, Paragraph } = Typography;

interface IProps {
    onClose: () => void;
    featureName?: string;
    unlockLevel?: string;
}

export const UpgradeModal: React.FunctionComponent<IProps> = (props) => {
    const navigate = useNavigate();
    const intl = useIntl();
    
    const handleViewFeatures = () => {
        navigate('/dashboard/organisation', { state: { activeTab: 'features' } });
        props.onClose();
    };

    return (
        <>
            <Title level={3}><LockOutlined /> {intl.formatMessage({ id: 'upgrade.title' }) || 'Upgrade Required'}</Title>
            <Paragraph>
                {props.featureName ? 
                    intl.formatMessage(
                        { id: 'upgrade.featureDescription' },
                        { feature: props.featureName, plan: props.unlockLevel }
                    ) || `To use ${props.featureName}, you need to upgrade your plan to ${props.unlockLevel}.` :
                    intl.formatMessage({ id: 'upgrade.generalDescription' }) || 'To unlock this feature, you need to upgrade your plan.'}
            </Paragraph>
            <Space>
                <Button onClick={props.onClose}>
                    {intl.formatMessage({ id: 'common.cancel' }) || 'Cancel'}
                </Button>
                <Button 
                    type="primary" 
                    icon={<RocketOutlined />} 
                    onClick={handleViewFeatures}
                >
                    {intl.formatMessage({ id: 'upgrade.viewFeatures' }) || 'View Features'}
                </Button>
            </Space>
        </>
    );
};
